import { Outlet } from "react-router-dom";
import { useSessao } from "@/sessao/useSessao";
import { useVisaoGeral } from "@/api/consultas";
import { Cabecalho } from "./Cabecalho";
import { BarraLateral } from "./BarraLateral";

/*
 * A moldura da aplicação (doc 06a §4.1).
 *
 * A visão geral é buscada AQUI, e não em cada tela: o contador de indeterminados
 * da barra lateral e o atraso do relay do rodapé vivem na moldura, e o TanStack
 * Query compartilha a mesma entrada de cache com a tela de Visão geral — uma
 * requisição a cada dez segundos, e não duas.
 */
export function Chassi() {
  const { cliente, estado } = useSessao();
  const { data: visao } = useVisaoGeral(cliente, estado.fase === "dentro");

  return (
    <div className="flex h-dvh flex-col bg-breu">
      <Cabecalho />
      <div className="flex min-h-0 flex-1">
        <BarraLateral visao={visao} />
        {/*
          `min-w-0` porque um filho com conteúdo largo — tabela densa, linha
          digitável — estouraria o flex e faria a página inteira rolar na
          horizontal, em vez de rolar dentro da própria área.
        */}
        <main className="min-w-0 flex-1 overflow-auto p-3">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
